import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15f084db"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-orientation"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("hr", {
    class: _normalizeClass(_ctx.classes),
    style: _normalizeStyle(_ctx.style),
    role: "separator",
    "aria-orientation": _ctx.areaOrientation
  }, null, 14, _hoisted_1))
}